<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
    	<!----------- 所有退货记录查询条件 -------------->
    	<el-form :inline="true" class="backborder1 demo-form-inline" size="small">
    		<el-form-item style="width:22%">
    			<el-date-picker v-model="order.date" clearable type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:100%" @change="orderisselect=true"></el-date-picker>
    		</el-form-item>
    		<el-form-item style="width:12%">
	    		<el-select v-model="order.applyid" clearable placeholder="请选择供应商" @change="orderisselect=true">
			        <el-option v-for="(item,index) in allapplylists" :key="index" :label="item.apply_name" :value="item.id"></el-option>
			    </el-select>
    		</el-form-item>
    		<el-form-item style="width:12%">
	    		<el-select v-model="order.warehouse" clearable placeholder="请选择仓库" @change="orderisselect=true">
			        <el-option v-for="(item,index) in wareHouseLists" :label="item.name" :value="item.id" :key="index"></el-option>
			    </el-select>
    		</el-form-item>
    		<el-form-item style="width:14%">
    			<el-input placeholder="请输入订单号" v-model="order.key" clearable style="width:100%" @change="orderisselect=true"></el-input>
    		</el-form-item>
    		<el-form-item>
    			<el-button type="primary" icon="el-icon-search" @click="getOrderlists">查询</el-button>
    			<el-button type="danger" icon="el-icon-edit-outline" @click="settlemoreorder" :loading="settlemoreLoading">批量结算</el-button>
    		</el-form-item>
    	</el-form>
    	
    	<div class="backborder2" style="margin-top:10px">
	    	<el-table :data="orderlists" ref="multipleTable" style="width: 100%" v-loading="orderListLoading" @row-click="selectrow" @selection-change="handleSelectionChange">
	    		<el-table-column type="selection" width="40"></el-table-column>
	    		<el-table-column type="expand">
		            <template slot-scope="props">
		                <el-table :data="props.row.goods">
			                <el-table-column prop="name" label="商品名称"></el-table-column>
			                <el-table-column prop="num" label="数量" width="100" align="center"></el-table-column>
			                <el-table-column prop="unit" label="单位" width="100" align="center"></el-table-column>
			                <el-table-column prop="buy" label="进货价" width="100" align="center"></el-table-column>
			                <el-table-column prop="total" label="小计" width="100" align="center"></el-table-column>
			                <el-table-column prop="total" label="状态" width="100" align="center">
			                	<template slot-scope="scope">
			                		<el-tag type="info" v-if="scope.row.status==3">已退货</el-tag>
			                		<el-tag type="success" v-if="scope.row.status==2">正常</el-tag>
			                	</template>
			                </el-table-column>
		                </el-table>
		            </template>
	            </el-table-column>
	    		
		        <el-table-column label="进货单号" prop="documents" width="150"></el-table-column>
		        <el-table-column label="供货商" prop="applyname" width="130"></el-table-column>
		        <el-table-column label="仓库" prop="warehousename" align="center"></el-table-column>
		        <el-table-column label="订单合计" prop="total" align="center"></el-table-column>
		        <el-table-column label="已付金额" prop="paytotal" align="center"></el-table-column>
		        <el-table-column label="退货商品总额" prop="refundtotal" align="center"></el-table-column>
		        <el-table-column label="剩余结算金额" prop="lasttotal" align="center">
		        	<template slot-scope="scope">
		        		<span v-if="scope.row.lasttotal > 0" style="color:#F56C6C">{{scope.row.lasttotal}}</span>
		        		<span v-if="scope.row.lasttotal == 0" style="color:#67C23A">{{scope.row.lasttotal}}</span>
		        	</template>
		        </el-table-column>
		        <el-table-column label="操作人" prop="managername" align="center"></el-table-column>
		        <el-table-column label="进货时间" prop="inputtime" align="center"></el-table-column>	        
		        <el-table-column label="操作" align="center">
		        	<template slot-scope="scope">
		        		<el-button size="small" type="primary" icon="el-icon-document" circle @click="showaccounts(scope.row)"></el-button>
		        	    <el-button size="small" type="danger" icon="el-icon-edit-outline" circle @click="settleorder(scope.row)"></el-button>
		        	</template>
		        </el-table-column>
	      	</el-table>
	      	<div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="orderPageSizeChange"
		            @current-change="orderPageCurrentChange"
		            :current-page="order.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="order.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="total_order_rows">
	            </el-pagination>
	            <!--分页end-->
	      	</div>
      	</div>
      	
      	<!-----------  结算金额界面  ------------>
      	<el-dialog title="结算" :visible.sync="settleDialog" width="25%" top="15vh">
      		<el-form :inline="true" class="demo-form-inline" size="medium">
    			<el-form-item label="待付货款">
    				<el-input v-model="settle.payamount" readonly></el-input>
    			</el-form-item>
    			<el-form-item label="结算金额">
    				<el-input v-model="settle.amount"></el-input>
    			</el-form-item>
    			<el-form-item label="支付方式">
	    			<el-select v-model="settle.account" clearable filterable placeholder="请选支付方式" @change="orderisselect=true">
						<el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id" v-if="item.id!=''"></el-option>
					</el-select>
    			</el-form-item>
    		</el-form>
    		<div slot="footer" class="dialog-footer">
	        	<el-button size="medium" @click="settleDialog=false">取 消</el-button>
	        	<el-button size="medium" type="danger" @click="savesettle" icon="el-icon-edit-outline" :loading="settlelLoading">结算</el-button>
	    	</div>
      	</el-dialog>
    	
    	<!---- 支付方式流水 ---->
    	<el-dialog title="支付记录" :visible.sync="accountlistsDialog" width="50%" top="15vh">
    		<el-table :data="paylists" style="width: 100%" border v-loading="accountlistsLoading">
				<el-table-column label="结算方式" prop="accountname" align="center"></el-table-column>
				<el-table-column label="结算金额" prop="amount" align="center"></el-table-column>
				<el-table-column label="结算时间" prop="inputtime" align="center"></el-table-column>
      		</el-table>
      		<div slot="footer" class="dialog-footer">
	        	<el-button size="medium" @click="accountlistsDialog=false">取 消</el-button>
	    	</div>
    	</el-dialog>
    	
    	<!-----------  批量结算金额界面  ------------>
      	<el-dialog title="结算" :visible.sync="settlemoreDialog" width="25%" top="15vh">
      		<el-form :inline="true" class="demo-form-inline" size="medium">
    			<el-form-item label="待付货款">
    				<el-input v-model="settlemore.amount" readonly></el-input>
    			</el-form-item>
    			<el-form-item label="支付方式">
	    			<el-select v-model="settlemore.account" clearable filterable placeholder="请选支付方式" @change="orderisselect=true">
						<el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id" v-if="item.id!=''"></el-option>
					</el-select>
    			</el-form-item>
    		</el-form>
    		<div slot="footer" class="dialog-footer">
	        	<el-button size="medium" @click="settlemoreDialog=false">取 消</el-button>
	        	<el-button size="medium" type="danger" @click="savesettlemore" icon="el-icon-edit-outline" :loading="settlemoreamountLoading">结算</el-button>
	    	</div>
      	</el-dialog>    	
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Stat/index",
      transitionshow:true,
      actionauth:[],
      total_order_rows:0,
      orderListLoading:false,
      orderisselect:false,
      wareHouseLists:[],
      accountLists:[],
      order:{
      	act:'getaccountstorage',
		token:this.$cookies.get('token'),
		date:'',
		applyid:'',
		warehouse:'',
		key:'',
		p:1,
		rollpage:10
      },
      settleDialog:false,
 	  settle: {
 	  	id:'',
 	  	act:'storagesettle',
 	  	token:this.$cookies.get('token'),
 	  	payamount:0.00,
 	  	amount:'',
 	  	account:'',
 	  },
 	  settlemore: {
 	  	id:'',
 	  	act:'storagesettlemore',
 	  	token:this.$cookies.get('token'),
 	  	amount:'',
 	  	account:'',
 	  },
 	  settlelLoading:false,
 	  accountlistsLoading:false,
 	  accountlistsDialog:false,
 	  paylists:[],
 	  settlemoreLoading:false,
 	  settleorders:[],
 	  pclickstatus:[],
 	  multipleSelection:[],
 	  settlemoreDialog:false,
 	  settlemoreamountLoading:false,
 	  allapplylists:[],
    }
  },
  mounted(){
  	this.getactionauth(); //获取权限设置
    this.getWarehouse();
    this.getAccount();
    this.getOrderlists(); //获取销售订单列表
    this.getAllapplylists(); //供应商信息
  },
  methods:{
  
    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
    },
    
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 获取全部供应商列表 **/
    getAllapplylists() {
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({act:'getapplyAll',token:this.$cookies.get('token')}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login');
                this.$message.error(res.data.Message);;
            }else{
				this.allapplylists=JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
        	this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    //获取订单信息列表
    getOrderlists() {
    	if(this.orderisselect==true) {
    		this.order.p=1;
    		this.order.rollpage=10;
    	}
    
    	this.orderListLoading=true;
    	var resource = this.$resource(this.url);
        resource.query(this.order).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.orderListLoading=false;
            }else{
                this.orderlists = JSON.parse(Base64.decode(res.data.Data));
                this.total_order_rows=parseInt(res.data.count);
                this.orderListLoading=false;
                
                var _this=this;
                this.pclickstatus=[];
	            this.orderlists.forEach(function() {_this.pclickstatus.push(0)});	                            
                if(this.orderisselect==true) this.orderisselect=false;
            }
        }).catch((res) => {
            this.orderListLoading=false;
        });
    },
    
    orderPageSizeChange(val) {
        this.order.rollpage = val;
        this.getOrderlists();
    },
    orderPageCurrentChange(val) {
        this.order.p = val;
        this.getOrderlists();
    },
    
    /** 获取仓库 **/
    getWarehouse(){
      var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        }else{
          this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    
    /** 获取银行帐户 **/
    getAccount(){
        var resource = this.$resource(this.GLOBAL.domain+"Account/index");
        resource.query({act:'lists',isnopay:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.accountLists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    //结算
    settleorder(item) {
    	this.settle.id=item.id;
    	this.settle.payamount=item.lasttotal;
    	this.settle.amount=0.00;
    	this.settleDialog=true;
    },
    
    //确认结算
    savesettle() {
    	this.$confirm('您是否确定对该订单进行结算, 是否继续?', '提示', { type: 'warning' }).then(() => {
        	this.settlelLoading=true;
        	var resource = this.$resource(this.url);
	        resource.query(this.settle).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.settlelLoading=false;
		        }else{
		        	this.$message.success('订单结算成功');
		            this.settlelLoading=false;
		            this.settleDialog=false;
		            this.getOrderlists();
		        }
	        }).catch((res) => {
	          	this.settlelLoading=false;
	        });
        	
        }).catch(() => {
        	this.$message.info('已取消操作!');
        });
    },
    
    //获取支付列表
    showaccounts(item) {
    	this.accountlistsLoading=true;
    	var resource = this.$resource(this.url);
	    resource.query({act:'showaccountlists',id:item.id,token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.accountlistsLoading=false;
		    }else{
		    	this.paylists = JSON.parse(Base64.decode(res.data.Data));
		        this.accountlistsLoading=false;
		        this.accountlistsDialog=true;
		    }
	    }).catch((res) => {
	    	this.accountlistsLoading=false;
	    });
    },
    
    
    /** 点击单行触发事件 **/
    selectrow(row,event,column) {
    	var id=row.id;
    	var number=0;
    	var dindex=0;
    	var isselect=0;
    	var _this=this;
    	
    	//获取当前商品在商品列表里的位置
    	this.orderlists.forEach(function(e,index) {if(id==e.id) number=index});
    	//给该位置进行勾选或取消勾选
    	this.pclickstatus[number]==0 ? this.pclickstatus[number]=1 : this.pclickstatus[number]=0;
		//判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品
		this.$refs.multipleTable.toggleRowSelection(this.orderlists[number]);
    },
    
    
    /** 订单列表选择有变动时触发 **/
    handleSelectionChange(val) {
    	var _this=this;
    	this.multipleSelection=[]; //清空获取的订单id
		val.forEach(function(item,i) {_this.multipleSelection.push(item.id)}); //获取已选中的订单id
		this.orderlists.forEach(function(item,i) { //更新商品的状态
			//查询订单id在选中的数组里是否存在
			_this.multipleSelection.indexOf(item.id)!=-1 ? _this.pclickstatus[i]=1 : _this.pclickstatus[i]=0;
		}); 	    	
    },
    
    
    //获取订单批量结算金额
    settlemoreorder() {
    	if(this.multipleSelection.length==0) {this.$message.error("请选择要结算的订单");return false;}
    	if(this.multipleSelection.length > 20) {this.$message.error("请一次性不要结算超过20个订单");return false;}
    	this.settlemoreLoading=true;
    	
    	var resource = this.$resource(this.url);
	    resource.save({act:'getmoresettleinfos',ids:this.multipleSelection,token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		        this.settlemoreLoading=false;
		    }else{
		    	var result = JSON.parse(Base64.decode(res.data.Data));
		    	this.settlemore.id=this.multipleSelection;
		    	this.settlemore.amount=result.amount;
		        this.settlemoreLoading=false;
		        this.settlemoreDialog=true;
		    }
	    }).catch((res) => {
	    	this.settlemoreLoading=false;
	    });
    },
    
    
    /** 保存批量结算金额 **/
    savesettlemore() {
    	this.$confirm('您是否确定批量对选中的订单进行结算, 是否继续?', '提示', { type: 'warning' }).then(() => {
        	this.settlemoreamountLoading=true;
        	var resource = this.$resource(this.url);
	        resource.save(this.settlemore).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.settlemoreamountLoading=false;
		            this.$message.error(res.data.Message);
		        }else{
		        	this.$message.success('订单批量结算成功！');
		            this.settlemoreamountLoading=false;
		            this.settlemoreDialog=false;
		            this.getOrderlists();
		        }
	        }).catch((res) => {
	          	this.settlemoreamountLoading=false;
	        });
        	
        }).catch(() => {
        	this.$message.info('已取消操作!');
        });
    },
    
     
  }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.titlelists {float:left;width:100%;padding:0;margin:0}
.titlelists li {float:left;width:33.3%;font-size:15px;list-style-type:none}
.top1 td {padding-top:5px;font-size:15px}
.top2 td {padding-top:15px;font-size:15px}
</style>


// WEBPACK FOOTER //
// src/components/stat/Storage.vue